import React from "react";
import { CheckCircle2, Star } from "lucide-react";
import '../../styles/cmyuva.css';
import logo1 from "../../assets/images/png/partners_logo_1.png"
import logo2 from "../../assets/images/png/partners_logo_2.jpg"
import logo3 from "../../assets/images/png/partners_logo_3.jpg"
import logo4 from "../../assets/images/png/partners_logo_4.jpg"
import logo5 from "../../assets/images/png/partners_logo_5.jpg"
import logo6 from "../../assets/images/png/partners_logo_6.png"

const CmYuvaAbout = () => {
  return (
    <section className="cmyuva_about_section">
      <div className="container">
        <div className="row align-items-center">
          
          <div className="col-lg-6 mb-5 mb-lg-0 pe-lg-5" data-aos="fade-right">
            <h3 className="cmyuva_section_title">About HKI Digital Media Studio</h3>
            
            {/* <p className="cmyuva_section_description mb-4">
              HKI Media is a next-generation AI-powered startup sitting at the intersection of <strong>storytelling, skilling, and immersive technology</strong>.
            </p>
            
            <div className="p-4 backdrop-blur-md bg-white/[0.03] rounded-3 border border-white/10 mb-4">
              <p className="mb-0 fst-italic text-gray-300">
                "Years of work across media education and content production revealed India's fragmented creative landscape. This insight led to <strong>GigMedia</strong>—transforming India's creative ecosystem."
              </p>
            </div>

            <ul className="cmyuva_feature_list">
              <li className="d-flex align-items-center gap-3">
                <CheckCircle2 className="cmyuva_text_theme" /> <span>AI-Enabled Skill Platform</span>
              </li>
              <li className="d-flex align-items-center gap-3">
                <CheckCircle2 className="cmyuva_text_theme" /> <span>Connecting Creators with Brands</span>
              </li>
              <li className="d-flex align-items-center gap-3">
                <CheckCircle2 className="cmyuva_text_theme" /> <span>Next-Gen Storytelling</span>
              </li>
            </ul> */}
            <p className="cmyuva_section_description mb-4">
              HKI Media Studio is a ready-to-operate Media Studio franchise developed by <strong>HKI Media</strong> and aligned with the <strong>CM Yuva Udyami Yojana</strong>.
            <br/>It empowers youth to start their own professional studio offering services like
            </p>

            <ul className="cmyuva_feature_list">
              <li className="d-flex align-items-center gap-3">
                <CheckCircle2 className="cmyuva_text_theme" /> <span>Editing, Graphics</span>
              </li>
              <li className="d-flex align-items-center gap-3">
                <CheckCircle2 className="cmyuva_text_theme" /> <span>VFX, Animation</span>
              </li>
              <li className="d-flex align-items-center gap-3">
                <CheckCircle2 className="cmyuva_text_theme" /> <span>Digital Marketing, Content Creation</span>
              </li>
              <li className="d-flex align-items-center gap-3">
                <CheckCircle2 className="cmyuva_text_theme" /> <span>Game Development</span>
              </li>
            </ul>
            <div className="p-4 backdrop-blur-md bg-white/[0.03] rounded-3 border border-white/10 mb-4">
              <p className="mb-0 fst-italic text-gray-300">
              Franchise partners receive complete support—training, SOPs, branding, technology guidance, and live project exposure—with continuous work opportunities through <strong>HKI Media</strong> & the <strong>GigMedia App.</strong>
              </p>
            </div>

          </div>

          <div className="col-lg-6" data-aos="fade-left">
            <div className="cmyuva_brands_grid backdrop-blur-md bg-white/[0.03] shadow-sm p-4 rounded-4 border border-white/10">
              <div className="d-flex align-items-center justify-content-between mb-4">
                <h4 className="mb-0 fw-bold">Trusted Partners</h4>
                <div className="d-flex gap-1 text-warning">
                  <Star size={16} fill="currentColor"/>
                  <Star size={16} fill="currentColor"/>
                  <Star size={16} fill="currentColor"/>
                  <Star size={16} fill="currentColor"/>
                  <Star size={16} fill="currentColor"/>
                </div>
              </div>
              {/* ADDED LOGOS AND CSS FOR THEM */}
              <div className="row g-3">
                {[logo1, logo2, logo3, logo4, logo5, logo6].map((item) => (
                  <div key={item} className="col-4">
                    <div className="cmyuva_brand_box">
                      {/* <span className="text-muted fw-bold small">LOGO {item}</span> */}
                      <span>
                        <img loading="lazy" decoding="async" className="cmyuva_about_partner_logo" src={item} alt="partner logos"/>
                      </span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default CmYuvaAbout;
